export const chartAlignment = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
};
